import _asyncToGenerator from "E:/dayinjia/Vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.function.name.js";
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-33fc3340"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "tabs"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "全局设置", -1);
});

var _hoisted_3 = [_hoisted_2];

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "显示设置", -1);
});

var _hoisted_5 = [_hoisted_4];

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "目录", -1);
});

var _hoisted_7 = [_hoisted_6];

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "页眉", -1);
});

var _hoisted_9 = [_hoisted_8];

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "检索表", -1);
});

var _hoisted_11 = [_hoisted_10];

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "吊线图设置", -1);
});

var _hoisted_13 = [_hoisted_12];

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "源流设置", -1);
});

var _hoisted_15 = [_hoisted_14];

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "行传设置", -1);
});

var _hoisted_17 = [_hoisted_16];
var _hoisted_18 = {
  class: "content"
};
var _hoisted_19 = ["v-model"];
var _hoisted_20 = {
  class: "name"
};
var _hoisted_21 = ["onClick"];
var _hoisted_22 = {
  class: "detail"
};
var _hoisted_23 = {
  class: "set-box"
};
var _hoisted_24 = {
  class: "set-title"
};
var _hoisted_25 = {
  class: "set-box"
};
var _hoisted_26 = {
  class: "set-title"
};
var _hoisted_27 = {
  class: "set-box"
};
var _hoisted_28 = {
  class: "set-title"
};
var _hoisted_29 = {
  class: "set-box"
};
var _hoisted_30 = {
  class: "set-title"
};
var _hoisted_31 = {
  class: "set-box"
};
var _hoisted_32 = {
  class: "set-title"
};
var _hoisted_33 = {
  class: "set-box"
};
var _hoisted_34 = {
  class: "set-title"
};
var _hoisted_35 = {
  class: "set-box"
};
var _hoisted_36 = {
  class: "set-title"
};
var _hoisted_37 = {
  class: "set-box"
};
var _hoisted_38 = {
  class: "set-title"
};
var _hoisted_39 = {
  class: "value-pagesize"
};

var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "mm", -1);
});

var _hoisted_41 = {
  class: "set-box"
};
var _hoisted_42 = {
  class: "set-title"
};
var _hoisted_43 = {
  class: "set-box"
};
var _hoisted_44 = {
  class: "set-title"
};
var _hoisted_45 = {
  class: "set-box"
};
var _hoisted_46 = {
  class: "set-title"
};
var _hoisted_47 = {
  class: "set-box"
};
var _hoisted_48 = {
  class: "set-title"
};
var _hoisted_49 = {
  class: "set-box"
};
var _hoisted_50 = {
  class: "set-title"
};
var _hoisted_51 = {
  class: "set-box"
};
var _hoisted_52 = {
  class: "set-title"
};
var _hoisted_53 = {
  class: "set-box"
};
var _hoisted_54 = {
  class: "set-title"
};
var _hoisted_55 = {
  class: "set-box"
};
var _hoisted_56 = {
  class: "set-title"
};
var _hoisted_57 = {
  class: "set-box"
};
var _hoisted_58 = {
  class: "set-title"
};
var _hoisted_59 = {
  class: "set-box"
};
var _hoisted_60 = {
  class: "set-title"
};
var _hoisted_61 = {
  class: "set-box"
};
var _hoisted_62 = {
  class: "set-title"
};
var _hoisted_63 = {
  class: "set-box"
};
var _hoisted_64 = {
  class: "set-title"
};
var _hoisted_65 = {
  class: "set-box"
};
var _hoisted_66 = {
  class: "set-title"
};
var _hoisted_67 = {
  class: "set-box"
};
var _hoisted_68 = {
  class: "set-title"
};
var _hoisted_69 = {
  class: "s-left"
};
var _hoisted_70 = {
  class: "section"
};
var _hoisted_71 = {
  class: "title"
};
var _hoisted_72 = {
  class: "section"
};
var _hoisted_73 = {
  class: "title"
};
var _hoisted_74 = {
  class: "section"
};
var _hoisted_75 = {
  class: "title"
};
var _hoisted_76 = {
  class: "section"
};
var _hoisted_77 = {
  class: "title"
};
var _hoisted_78 = {
  class: "section"
};
var _hoisted_79 = {
  class: "title"
};
var _hoisted_80 = {
  class: "section"
};
var _hoisted_81 = {
  class: "title"
};
var _hoisted_82 = {
  class: "section"
};
var _hoisted_83 = {
  class: "title"
};
var _hoisted_84 = {
  class: "s-left"
};
var _hoisted_85 = {
  class: "section"
};
var _hoisted_86 = {
  class: "title"
};
var _hoisted_87 = {
  class: "section"
};
var _hoisted_88 = {
  class: "title"
};
var _hoisted_89 = {
  class: "section"
};
var _hoisted_90 = {
  class: "title"
};
var _hoisted_91 = {
  class: "section"
};
var _hoisted_92 = {
  class: "title"
};
var _hoisted_93 = {
  class: "section"
};
var _hoisted_94 = {
  class: "title"
};
var _hoisted_95 = {
  class: "section"
};
var _hoisted_96 = {
  class: "title"
};
var _hoisted_97 = {
  class: "section"
};
var _hoisted_98 = {
  class: "title"
};
var _hoisted_99 = {
  class: "section"
};
var _hoisted_100 = {
  class: "title"
};
var _hoisted_101 = {
  class: "section"
};
var _hoisted_102 = {
  class: "title"
};
var _hoisted_103 = {
  class: "section"
};
var _hoisted_104 = {
  class: "title"
};
var _hoisted_105 = {
  class: "section"
};
var _hoisted_106 = {
  class: "title"
};
var _hoisted_107 = {
  class: "s-left"
};
var _hoisted_108 = {
  class: "section"
};
var _hoisted_109 = {
  class: "title"
};
var _hoisted_110 = {
  class: "section"
};
var _hoisted_111 = {
  class: "title"
};
var _hoisted_112 = {
  class: "section"
};
var _hoisted_113 = {
  class: "title"
};
var _hoisted_114 = {
  class: "s-left"
};
var _hoisted_115 = {
  class: "section"
};
var _hoisted_116 = {
  class: "title"
};
var _hoisted_117 = {
  class: "section"
};
var _hoisted_118 = {
  class: "title"
};
var _hoisted_119 = {
  class: "section"
};
var _hoisted_120 = {
  class: "title"
};
var _hoisted_121 = {
  class: "s-left"
};
var _hoisted_122 = {
  class: "section"
};
var _hoisted_123 = {
  class: "title"
};
var _hoisted_124 = {
  class: "section"
};
var _hoisted_125 = {
  class: "title"
};
var _hoisted_126 = {
  class: "section"
};
var _hoisted_127 = {
  class: "title"
};
var _hoisted_128 = {
  class: "s-left"
};
var _hoisted_129 = {
  class: "section"
};
var _hoisted_130 = {
  class: "title"
};
var _hoisted_131 = {
  class: "section"
};
var _hoisted_132 = {
  class: "title"
};
var _hoisted_133 = {
  class: "section"
};
var _hoisted_134 = {
  class: "title"
};
var _hoisted_135 = {
  class: "section"
};
var _hoisted_136 = {
  class: "title"
};
var _hoisted_137 = {
  class: "section"
};
var _hoisted_138 = {
  class: "title"
};
var _hoisted_139 = {
  class: "section"
};
var _hoisted_140 = {
  class: "title"
};
var _hoisted_141 = {
  class: "section"
};
var _hoisted_142 = {
  class: "title"
};
var _hoisted_143 = {
  class: "s-left"
};
var _hoisted_144 = {
  class: "section"
};
var _hoisted_145 = {
  class: "title"
};
var _hoisted_146 = {
  class: "s-left"
};
var _hoisted_147 = {
  class: "section"
};
var _hoisted_148 = {
  class: "title"
};
var _hoisted_149 = {
  class: "section"
};

var _hoisted_150 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, [/*#__PURE__*/_createElementVNode("span", null, "自定义日期格式")], -1);
});

var _hoisted_151 = {
  class: "date-format"
};

var _hoisted_152 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "hint"
  }, [/*#__PURE__*/_createElementVNode("div", null, "格式: {关键词}自定义文字{关键词}{关键词}"), /*#__PURE__*/_createElementVNode("div", null, " 可选: {朝}{朝代}{帝王号}{帝王号+年号}{花甲}{数字年}{公历年}{公历月}{农历月}{公历日}{农历日} ")], -1);
});

var _hoisted_153 = {
  class: "section"
};
var _hoisted_154 = {
  class: "title"
};
var _hoisted_155 = {
  class: "section"
};
var _hoisted_156 = {
  class: "title"
};
var _hoisted_157 = {
  class: "section"
};
var _hoisted_158 = {
  class: "title"
};
var _hoisted_159 = {
  class: "section"
};
var _hoisted_160 = {
  class: "title"
};
var _hoisted_161 = {
  class: "section"
};
var _hoisted_162 = {
  class: "title"
};
var _hoisted_163 = {
  class: "section"
};
var _hoisted_164 = {
  class: "title"
};
var _hoisted_165 = {
  class: "section"
};
var _hoisted_166 = {
  class: "title"
};
var _hoisted_167 = {
  class: "section"
};
var _hoisted_168 = {
  class: "title"
};
var _hoisted_169 = {
  class: "section"
};
var _hoisted_170 = {
  class: "title"
};
var _hoisted_171 = {
  class: "section"
};
var _hoisted_172 = {
  class: "title"
};
var _hoisted_173 = {
  for: ""
};
var _hoisted_174 = {
  class: "section"
};
var _hoisted_175 = {
  class: "title"
};
var _hoisted_176 = {
  class: "section"
};
var _hoisted_177 = {
  class: "title"
};
var _hoisted_178 = {
  class: "section"
};
var _hoisted_179 = {
  class: "title"
};
var _hoisted_180 = {
  class: "section"
};
var _hoisted_181 = {
  class: "title"
};
var _hoisted_182 = {
  class: "section"
};
var _hoisted_183 = {
  class: "title"
};
var _hoisted_184 = {
  class: "section"
};
var _hoisted_185 = {
  class: "title"
};
var _hoisted_186 = {
  class: "section"
};
var _hoisted_187 = {
  class: "title"
};
var _hoisted_188 = {
  class: "section"
};
var _hoisted_189 = {
  class: "title"
};
var _hoisted_190 = {
  class: "m-right"
};
var _hoisted_191 = {
  class: "btns"
};

var _hoisted_192 = /*#__PURE__*/_createTextVNode("应用并返回");

var _hoisted_193 = /*#__PURE__*/_createTextVNode("应用");

var _hoisted_194 = /*#__PURE__*/_createTextVNode("取消");

var _hoisted_195 = /*#__PURE__*/_createTextVNode("保存设置");

var _hoisted_196 = /*#__PURE__*/_createTextVNode("载入设置");

var _hoisted_197 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top-bar"
  }, [/*#__PURE__*/_createTextVNode(" 样式范例 "), /*#__PURE__*/_createElementVNode("span", {
    class: "tips"
  }, "(实际展示效果，请在谱书预览查看)")], -1);
});

var _hoisted_198 = {
  class: "preview-wrap"
};
var _hoisted_199 = {
  class: "page"
};
var _hoisted_200 = {
  class: "page-left"
};
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { configDefault } from './components/configDefault';
import { getBookDetail, saveBook } from '@/api/book';
import { ElMessage } from 'element-plus';
export default {
  setup: function setup(__props) {
    var tabIndex = ref(0);
    var config = ref(null);
    var bookData = ref({});
    var route = useRoute();

    var handleChange = function handleChange(value) {
      console.log(value);
    };

    var initData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(route.query.id);
                _context.next = 3;
                return getBookDetail(route.query.id);

              case 3:
                res = _context.sent;
                console.log(res.config.length); // config.value = configDefault

                if (JSON.stringify(res.config) === '{}' || res.config.length <= 0) {
                  config.value = configDefault;
                } else {
                  config.value = res.config;
                }

                bookData.value = res;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initData() {
        return _ref.apply(this, arguments);
      };
    }();

    initData();

    var handelSaveBook = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                bookData.value.config = config.value;
                _context2.next = 3;
                return saveBook(bookData.value);

              case 3:
                ElMessage({
                  message: '保存成功',
                  type: 'success'
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function handelSaveBook() {
        return _ref2.apply(this, arguments);
      };
    }();

    return function (_ctx, _cache) {
      var _component_el_radio = _resolveComponent("el-radio");

      var _component_el_radio_group = _resolveComponent("el-radio-group");

      var _component_el_input_number = _resolveComponent("el-input-number");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_carousel_item = _resolveComponent("el-carousel-item");

      var _component_el_carousel = _resolveComponent("el-carousel");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["item", {
          on: tabIndex.value == 0
        }]),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return tabIndex.value = 0;
        })
      }, "版式设置", 2), _createElementVNode("div", {
        class: _normalizeClass(["item", {
          on: tabIndex.value == 1
        }]),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return tabIndex.value = 1;
        })
      }, _hoisted_3, 2), _createElementVNode("div", {
        class: _normalizeClass(["item", {
          on: tabIndex.value == 2
        }]),
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return tabIndex.value = 2;
        })
      }, _hoisted_5, 2), _createElementVNode("div", {
        class: _normalizeClass(["item", {
          on: tabIndex.value == 3
        }]),
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return tabIndex.value = 3;
        })
      }, _hoisted_7, 2), _createElementVNode("div", {
        class: _normalizeClass(["item", {
          on: tabIndex.value == 4
        }]),
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return tabIndex.value = 4;
        })
      }, _hoisted_9, 2), _createElementVNode("div", {
        class: _normalizeClass(["item", {
          on: tabIndex.value == 5
        }]),
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return tabIndex.value = 5;
        })
      }, _hoisted_11, 2), _createElementVNode("div", {
        class: _normalizeClass(["item", {
          on: tabIndex.value == 6
        }]),
        onClick: _cache[6] || (_cache[6] = function ($event) {
          return tabIndex.value = 6;
        })
      }, _hoisted_13, 2), _createElementVNode("div", {
        class: _normalizeClass(["item", {
          on: tabIndex.value == 7
        }]),
        onClick: _cache[7] || (_cache[7] = function ($event) {
          return tabIndex.value = 7;
        })
      }, _hoisted_15, 2), _createElementVNode("div", {
        class: _normalizeClass(["item", {
          on: tabIndex.value == 8
        }]),
        onClick: _cache[8] || (_cache[8] = function ($event) {
          return tabIndex.value = 8;
        })
      }, _hoisted_17, 2)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
        class: "m-left",
        "v-model": config.value
      }, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.layoutType.select, function (item) {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item", {
            selected: item.value == config.value.layoutSettings.layoutType.value
          }]),
          key: item.value,
          onClick: function onClick($event) {
            return config.value.layoutSettings.layoutType.value = item.value;
          }
        }, _toDisplayString(item.name), 11, _hoisted_21);
      }), 128))]), _createElementVNode("div", _hoisted_22, _toDisplayString(config.value.layoutSettings.layoutType.select[config.value.layoutSettings.layoutType.value].detail), 1)]), _createElementVNode("div", null, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString(config.value.layoutSettings.searchTable.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.searchTable.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
          return config.value.layoutSettings.searchTable.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.searchTable.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString(config.value.layoutSettings.searchType.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.searchType.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
          return config.value.layoutSettings.searchType.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.searchType.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(config.value.layoutSettings.searchPedigree.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.searchPedigree.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
          return config.value.layoutSettings.searchPedigree.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.searchPedigree.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(config.value.layoutSettings.sagasShow.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.sagasShow.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
          return config.value.layoutSettings.sagasShow.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.sagasShow.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(config.value.layoutSettings.direction.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.direction.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
          return config.value.layoutSettings.direction.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.direction.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString(config.value.layoutSettings.header.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.header.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
          return config.value.layoutSettings.header.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.header.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString(config.value.layoutSettings.binding.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.binding.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) {
          return config.value.layoutSettings.binding.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.binding.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, _toDisplayString(config.value.layoutSettings.bleed.title), 1), _createElementVNode("div", _hoisted_39, [_createVNode(_component_el_input_number, {
        modelValue: config.value.layoutSettings.bleed.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
          return config.value.layoutSettings.bleed.value = $event;
        }),
        min: 1,
        max: 10,
        size: "small",
        onChange: handleChange
      }, null, 8, ["modelValue"]), _hoisted_40])])], 512), [[_vShow, config.value.layoutSettings.layoutType.value != 5]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString(config.value.layoutSettings.sagasShow.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.sagasShow.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) {
          return config.value.layoutSettings.sagasShow.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.sagasShow.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _withDirectives(_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString(config.value.layoutSettings.searchTable.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.searchTable.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) {
          return config.value.layoutSettings.searchTable.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.searchTable.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])], 512), [[_vShow, config.value.layoutSettings.sagasShow.value == 1]]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, _toDisplayString(config.value.layoutSettings.direction.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.direction.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = function ($event) {
          return config.value.layoutSettings.direction.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.direction.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, _toDisplayString(config.value.layoutSettings.expand.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.expand.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
          return config.value.layoutSettings.expand.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.expand.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, _toDisplayString(config.value.layoutSettings.lineColor.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.lineColor.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) {
          return config.value.layoutSettings.lineColor.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.lineColor.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, _toDisplayString(config.value.layoutSettings.pendant.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.pendant.value,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = function ($event) {
          return config.value.layoutSettings.pendant.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.pendant.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _withDirectives(_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, _toDisplayString(config.value.layoutSettings.pendantType.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.pendantType.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = function ($event) {
          return config.value.layoutSettings.pendantType.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.pendantType.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])], 512), [[_vShow, config.value.layoutSettings.pendant.value != 0]]), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, _toDisplayString(config.value.layoutSettings.spouseDead.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.spouseDead.value,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = function ($event) {
          return config.value.layoutSettings.spouseDead.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.spouseDead.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, _toDisplayString(config.value.layoutSettings.spectrumShow.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.spectrumShow.value,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = function ($event) {
          return config.value.layoutSettings.spectrumShow.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.spectrumShow.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, _toDisplayString(config.value.layoutSettings.rankShow.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.rankShow.value,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = function ($event) {
          return config.value.layoutSettings.rankShow.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.rankShow.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, _toDisplayString(config.value.layoutSettings.nameFontSize.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.nameFontSize.value,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = function ($event) {
          return config.value.layoutSettings.nameFontSize.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.nameFontSize.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, _toDisplayString(config.value.layoutSettings.contentFontSize.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.contentFontSize.value,
        "onUpdate:modelValue": _cache[28] || (_cache[28] = function ($event) {
          return config.value.layoutSettings.contentFontSize.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.contentFontSize.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _withDirectives(_createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, _toDisplayString(config.value.layoutSettings.rankFontSize.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.rankFontSize.value,
        "onUpdate:modelValue": _cache[29] || (_cache[29] = function ($event) {
          return config.value.layoutSettings.rankFontSize.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.rankFontSize.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])], 512), [[_vShow, config.value.layoutSettings.rankShow.value == 0]]), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, _toDisplayString(config.value.layoutSettings.topFont.title), 1), _createVNode(_component_el_radio_group, {
        modelValue: config.value.layoutSettings.topFont.value,
        "onUpdate:modelValue": _cache[30] || (_cache[30] = function ($event) {
          return config.value.layoutSettings.topFont.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.layoutSettings.topFont.select, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              key: item.value,
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])], 512), [[_vShow, config.value.layoutSettings.layoutType.value == 5]])])], 512), [[_vShow, tabIndex.value == 0]]), _withDirectives(_createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createElementVNode("span", null, _toDisplayString(config.value.commonSettings.language.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.commonSettings.language.value,
        "onUpdate:modelValue": _cache[31] || (_cache[31] = function ($event) {
          return config.value.commonSettings.language.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.commonSettings.language.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_createElementVNode("span", null, _toDisplayString(config.value.commonSettings.languageChange.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.commonSettings.languageChange.value,
        "onUpdate:modelValue": _cache[32] || (_cache[32] = function ($event) {
          return config.value.commonSettings.languageChange.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.commonSettings.languageChange.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_createElementVNode("span", null, _toDisplayString(config.value.commonSettings.nameShowType.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.commonSettings.nameShowType.value,
        "onUpdate:modelValue": _cache[33] || (_cache[33] = function ($event) {
          return config.value.commonSettings.nameShowType.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.commonSettings.nameShowType.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createElementVNode("span", null, _toDisplayString(config.value.commonSettings.pedigreeRule.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.commonSettings.pedigreeRule.value,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = function ($event) {
          return config.value.commonSettings.pedigreeRule.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.commonSettings.pedigreeRule.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_createElementVNode("span", null, _toDisplayString(config.value.commonSettings.pedigreeShowMode.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.commonSettings.pedigreeShowMode.value,
        "onUpdate:modelValue": _cache[35] || (_cache[35] = function ($event) {
          return config.value.commonSettings.pedigreeShowMode.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.commonSettings.pedigreeShowMode.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_createElementVNode("span", null, _toDisplayString(config.value.commonSettings.twentyShow.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.commonSettings.twentyShow.value,
        "onUpdate:modelValue": _cache[36] || (_cache[36] = function ($event) {
          return config.value.commonSettings.twentyShow.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.commonSettings.twentyShow.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [_createElementVNode("span", null, _toDisplayString(config.value.commonSettings.titleMode.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.commonSettings.titleMode.value,
        "onUpdate:modelValue": _cache[37] || (_cache[37] = function ($event) {
          return config.value.commonSettings.titleMode.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.commonSettings.titleMode.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])], 512), [[_vShow, tabIndex.value == 1]]), _withDirectives(_createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_createElementVNode("span", null, _toDisplayString(config.value.showSettings.spouseShow.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.showSettings.spouseShow.value,
        "onUpdate:modelValue": _cache[38] || (_cache[38] = function ($event) {
          return config.value.showSettings.spouseShow.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.showSettings.spouseShow.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_createElementVNode("span", null, _toDisplayString(config.value.showSettings.sonShow.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.showSettings.sonShow.value,
        "onUpdate:modelValue": _cache[39] || (_cache[39] = function ($event) {
          return config.value.showSettings.sonShow.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.showSettings.sonShow.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_createElementVNode("span", null, _toDisplayString(config.value.showSettings.daughterShow.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.showSettings.daughterShow.value,
        "onUpdate:modelValue": _cache[40] || (_cache[40] = function ($event) {
          return config.value.showSettings.daughterShow.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.showSettings.daughterShow.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, [_createElementVNode("span", null, _toDisplayString(config.value.showSettings.daughterDescShow.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.showSettings.daughterDescShow.value,
        "onUpdate:modelValue": _cache[41] || (_cache[41] = function ($event) {
          return config.value.showSettings.daughterDescShow.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.showSettings.daughterDescShow.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_createElementVNode("span", null, _toDisplayString(config.value.showSettings.avatarShow.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.showSettings.avatarShow.value,
        "onUpdate:modelValue": _cache[42] || (_cache[42] = function ($event) {
          return config.value.showSettings.avatarShow.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.showSettings.avatarShow.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [_createElementVNode("span", null, _toDisplayString(config.value.showSettings.firstShow.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.showSettings.firstShow.value,
        "onUpdate:modelValue": _cache[43] || (_cache[43] = function ($event) {
          return config.value.showSettings.firstShow.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.showSettings.firstShow.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_97, [_createElementVNode("div", _hoisted_98, [_createElementVNode("span", null, _toDisplayString(config.value.showSettings.noBiographyShow.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.showSettings.noBiographyShow.value,
        "onUpdate:modelValue": _cache[44] || (_cache[44] = function ($event) {
          return config.value.showSettings.noBiographyShow.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.showSettings.noBiographyShow.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_99, [_createElementVNode("div", _hoisted_100, [_createElementVNode("span", null, _toDisplayString(config.value.showSettings.displayNoneShow.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.showSettings.displayNoneShow.value,
        "onUpdate:modelValue": _cache[45] || (_cache[45] = function ($event) {
          return config.value.showSettings.displayNoneShow.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.showSettings.displayNoneShow.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, [_createElementVNode("span", null, _toDisplayString(config.value.showSettings.spouseShowWord.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.showSettings.spouseShowWord.value,
        "onUpdate:modelValue": _cache[46] || (_cache[46] = function ($event) {
          return config.value.showSettings.spouseShowWord.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.showSettings.spouseShowWord.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_103, [_createElementVNode("div", _hoisted_104, [_createElementVNode("span", null, _toDisplayString(config.value.showSettings.addressShow.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.showSettings.addressShow.value,
        "onUpdate:modelValue": _cache[47] || (_cache[47] = function ($event) {
          return config.value.showSettings.addressShow.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.showSettings.addressShow.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_105, [_createElementVNode("div", _hoisted_106, [_createElementVNode("span", null, _toDisplayString(config.value.showSettings.spouseAaddressShow.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.showSettings.spouseAaddressShow.value,
        "onUpdate:modelValue": _cache[48] || (_cache[48] = function ($event) {
          return config.value.showSettings.spouseAaddressShow.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.showSettings.spouseAaddressShow.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])], 512), [[_vShow, tabIndex.value == 2]]), _withDirectives(_createElementVNode("div", _hoisted_107, [_createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createElementVNode("span", null, _toDisplayString(config.value.catalogueSettings.title.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.catalogueSettings.title.value,
        "onUpdate:modelValue": _cache[49] || (_cache[49] = function ($event) {
          return config.value.catalogueSettings.title.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.catalogueSettings.title.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_110, [_createElementVNode("div", _hoisted_111, [_createElementVNode("span", null, _toDisplayString(config.value.catalogueSettings.titleContent.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.catalogueSettings.titleContent.value,
        "onUpdate:modelValue": _cache[50] || (_cache[50] = function ($event) {
          return config.value.catalogueSettings.titleContent.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.catalogueSettings.titleContent.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_112, [_createElementVNode("div", _hoisted_113, [_createElementVNode("span", null, _toDisplayString(config.value.catalogueSettings.page.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.catalogueSettings.page.value,
        "onUpdate:modelValue": _cache[51] || (_cache[51] = function ($event) {
          return config.value.catalogueSettings.page.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.catalogueSettings.page.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])], 512), [[_vShow, tabIndex.value == 3]]), _withDirectives(_createElementVNode("div", _hoisted_114, [_createElementVNode("div", _hoisted_115, [_createElementVNode("div", _hoisted_116, [_createElementVNode("span", null, _toDisplayString(config.value.headSettings.note.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.headSettings.note.value,
        "onUpdate:modelValue": _cache[52] || (_cache[52] = function ($event) {
          return config.value.headSettings.note.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.headSettings.note.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_117, [_createElementVNode("div", _hoisted_118, [_createElementVNode("span", null, _toDisplayString(config.value.headSettings.titleContent.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.headSettings.titleContent.value,
        "onUpdate:modelValue": _cache[53] || (_cache[53] = function ($event) {
          return config.value.headSettings.titleContent.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.headSettings.titleContent.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_119, [_createElementVNode("div", _hoisted_120, [_createElementVNode("span", null, _toDisplayString(config.value.headSettings.pageNum.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.headSettings.pageNum.value,
        "onUpdate:modelValue": _cache[54] || (_cache[54] = function ($event) {
          return config.value.headSettings.pageNum.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.headSettings.pageNum.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])], 512), [[_vShow, tabIndex.value == 4]]), _withDirectives(_createElementVNode("div", _hoisted_121, [_createElementVNode("div", _hoisted_122, [_createElementVNode("div", _hoisted_123, [_createElementVNode("span", null, _toDisplayString(config.value.searchSettings.note.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.searchSettings.note.value,
        "onUpdate:modelValue": _cache[55] || (_cache[55] = function ($event) {
          return config.value.searchSettings.note.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.searchSettings.note.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_124, [_createElementVNode("div", _hoisted_125, [_createElementVNode("span", null, _toDisplayString(config.value.searchSettings.title.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.searchSettings.title.value,
        "onUpdate:modelValue": _cache[56] || (_cache[56] = function ($event) {
          return config.value.searchSettings.title.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.searchSettings.title.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_126, [_createElementVNode("div", _hoisted_127, [_createElementVNode("span", null, _toDisplayString(config.value.searchSettings.daughter.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.searchSettings.daughter.value,
        "onUpdate:modelValue": _cache[57] || (_cache[57] = function ($event) {
          return config.value.searchSettings.daughter.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.searchSettings.daughter.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])], 512), [[_vShow, tabIndex.value == 5]]), _withDirectives(_createElementVNode("div", _hoisted_128, [_createElementVNode("div", _hoisted_129, [_createElementVNode("div", _hoisted_130, [_createElementVNode("span", null, _toDisplayString(config.value.lineSettings.pedigreePage.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.lineSettings.pedigreePage.value,
        "onUpdate:modelValue": _cache[58] || (_cache[58] = function ($event) {
          return config.value.lineSettings.pedigreePage.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.lineSettings.pedigreePage.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_131, [_createElementVNode("div", _hoisted_132, [_createElementVNode("span", null, _toDisplayString(config.value.lineSettings.aliasNameNote.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.lineSettings.aliasNameNote.value,
        "onUpdate:modelValue": _cache[59] || (_cache[59] = function ($event) {
          return config.value.lineSettings.aliasNameNote.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.lineSettings.aliasNameNote.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_133, [_createElementVNode("div", _hoisted_134, [_createElementVNode("span", null, _toDisplayString(config.value.lineSettings.spouse.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.lineSettings.spouse.value,
        "onUpdate:modelValue": _cache[60] || (_cache[60] = function ($event) {
          return config.value.lineSettings.spouse.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.lineSettings.spouse.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_135, [_createElementVNode("div", _hoisted_136, [_createElementVNode("span", null, _toDisplayString(config.value.lineSettings.daughter.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.lineSettings.daughter.value,
        "onUpdate:modelValue": _cache[61] || (_cache[61] = function ($event) {
          return config.value.lineSettings.daughter.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.lineSettings.daughter.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_137, [_createElementVNode("div", _hoisted_138, [_createElementVNode("span", null, _toDisplayString(config.value.lineSettings.personPage.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.lineSettings.personPage.value,
        "onUpdate:modelValue": _cache[62] || (_cache[62] = function ($event) {
          return config.value.lineSettings.personPage.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.lineSettings.personPage.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_139, [_createElementVNode("div", _hoisted_140, [_createElementVNode("span", null, _toDisplayString(config.value.lineSettings.pageNote.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.lineSettings.pageNote.value,
        "onUpdate:modelValue": _cache[63] || (_cache[63] = function ($event) {
          return config.value.lineSettings.pageNote.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.lineSettings.pageNote.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_141, [_createElementVNode("div", _hoisted_142, [_createElementVNode("span", null, _toDisplayString(config.value.lineSettings.level.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.lineSettings.level.value,
        "onUpdate:modelValue": _cache[64] || (_cache[64] = function ($event) {
          return config.value.lineSettings.level.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.lineSettings.level.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])], 512), [[_vShow, tabIndex.value == 6]]), _withDirectives(_createElementVNode("div", _hoisted_143, [_createElementVNode("div", _hoisted_144, [_createElementVNode("div", _hoisted_145, [_createElementVNode("span", null, _toDisplayString(config.value.sourceNote.pedigree.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.sourceNote.pedigree.value,
        "onUpdate:modelValue": _cache[65] || (_cache[65] = function ($event) {
          return config.value.sourceNote.pedigree.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.sourceNote.pedigree.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])], 512), [[_vShow, tabIndex.value == 7]]), _withDirectives(_createElementVNode("div", _hoisted_146, [_createElementVNode("div", _hoisted_147, [_createElementVNode("div", _hoisted_148, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.dateTime.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.dateTime.value,
        "onUpdate:modelValue": _cache[66] || (_cache[66] = function ($event) {
          return config.value.biographySettings.dateTime.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.dateTime.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_149, [_hoisted_150, _createElementVNode("div", _hoisted_151, [_hoisted_152, _createVNode(_component_el_input, {
        modelValue: _ctx.input,
        "onUpdate:modelValue": _cache[67] || (_cache[67] = function ($event) {
          return _ctx.input = $event;
        }),
        placeholder: "{公历年}{公历月}{公历日}"
      }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_153, [_createElementVNode("div", _hoisted_154, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.chineseTime.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.chineseTime.value,
        "onUpdate:modelValue": _cache[68] || (_cache[68] = function ($event) {
          return config.value.biographySettings.chineseTime.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.chineseTime.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_155, [_createElementVNode("div", _hoisted_156, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.birthday.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.birthday.value,
        "onUpdate:modelValue": _cache[69] || (_cache[69] = function ($event) {
          return config.value.biographySettings.birthday.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.birthday.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_157, [_createElementVNode("div", _hoisted_158, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.burialDay.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.burialDay.value,
        "onUpdate:modelValue": _cache[70] || (_cache[70] = function ($event) {
          return config.value.biographySettings.burialDay.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.burialDay.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_159, [_createElementVNode("div", _hoisted_160, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.burialKey.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.burialKey.value,
        "onUpdate:modelValue": _cache[71] || (_cache[71] = function ($event) {
          return config.value.biographySettings.burialKey.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.burialKey.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_161, [_createElementVNode("div", _hoisted_162, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.burialKeyMode.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.burialKeyMode.value,
        "onUpdate:modelValue": _cache[72] || (_cache[72] = function ($event) {
          return config.value.biographySettings.burialKeyMode.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.burialKeyMode.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_163, [_createElementVNode("div", _hoisted_164, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.sonDisplay.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.sonDisplay.value,
        "onUpdate:modelValue": _cache[73] || (_cache[73] = function ($event) {
          return config.value.biographySettings.sonDisplay.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.sonDisplay.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_165, [_createElementVNode("div", _hoisted_166, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.deathAge.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.deathAge.value,
        "onUpdate:modelValue": _cache[74] || (_cache[74] = function ($event) {
          return config.value.biographySettings.deathAge.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.deathAge.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_167, [_createElementVNode("div", _hoisted_168, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.ranking.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.ranking.value,
        "onUpdate:modelValue": _cache[75] || (_cache[75] = function ($event) {
          return config.value.biographySettings.ranking.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.ranking.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_169, [_createElementVNode("div", _hoisted_170, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.rankingMode.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.rankingMode.value,
        "onUpdate:modelValue": _cache[76] || (_cache[76] = function ($event) {
          return config.value.biographySettings.rankingMode.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.rankingMode.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_171, [_createElementVNode("div", _hoisted_172, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.sonInLawRankingMode.title), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.sonInLawRankingMode.select, function (item) {
        return _openBlock(), _createElementBlock("div", {
          class: "value-list-flex",
          key: item.value
        }, [_createElementVNode("label", _hoisted_173, _toDisplayString(item.title), 1), _createVNode(_component_el_select, {
          modelValue: item.value,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return item.value = $event;
          },
          class: "value-list-select",
          placeholder: "Select",
          size: "small"
        }, {
          default: _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.select, function (a) {
              return _openBlock(), _createBlock(_component_el_option, {
                key: a.value,
                label: a.name,
                value: a.value
              }, null, 8, ["label", "value"]);
            }), 128))];
          }),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])]);
      }), 128))]), _createElementVNode("div", _hoisted_174, [_createElementVNode("div", _hoisted_175, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.sonInLaw.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.sonInLaw.value,
        "onUpdate:modelValue": _cache[77] || (_cache[77] = function ($event) {
          return config.value.biographySettings.sonInLaw.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.sonInLaw.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_176, [_createElementVNode("div", _hoisted_177, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.sonInLawBiography.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.sonInLawBiography.value,
        "onUpdate:modelValue": _cache[78] || (_cache[78] = function ($event) {
          return config.value.biographySettings.sonInLawBiography.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.sonInLawBiography.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_178, [_createElementVNode("div", _hoisted_179, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.aliasName.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.aliasName.value,
        "onUpdate:modelValue": _cache[79] || (_cache[79] = function ($event) {
          return config.value.biographySettings.aliasName.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.aliasName.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_180, [_createElementVNode("div", _hoisted_181, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.spouseName.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.spouseName.value,
        "onUpdate:modelValue": _cache[80] || (_cache[80] = function ($event) {
          return config.value.biographySettings.spouseName.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.spouseName.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_182, [_createElementVNode("div", _hoisted_183, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.sentancePause.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.sentancePause.value,
        "onUpdate:modelValue": _cache[81] || (_cache[81] = function ($event) {
          return config.value.biographySettings.sentancePause.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.sentancePause.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_184, [_createElementVNode("div", _hoisted_185, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.pedigreePage.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.pedigreePage.value,
        "onUpdate:modelValue": _cache[82] || (_cache[82] = function ($event) {
          return config.value.biographySettings.pedigreePage.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.pedigreePage.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_186, [_createElementVNode("div", _hoisted_187, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.separateTitle.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.separateTitle.value,
        "onUpdate:modelValue": _cache[83] || (_cache[83] = function ($event) {
          return config.value.biographySettings.separateTitle.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.separateTitle.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_188, [_createElementVNode("div", _hoisted_189, [_createElementVNode("span", null, _toDisplayString(config.value.biographySettings.separateTitleTopShow.title), 1)]), _createVNode(_component_el_radio_group, {
        modelValue: config.value.biographySettings.separateTitleTopShow.value,
        "onUpdate:modelValue": _cache[84] || (_cache[84] = function ($event) {
          return config.value.biographySettings.separateTitleTopShow.value = $event;
        }),
        class: "row"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.value.biographySettings.separateTitleTopShow.select, function (item) {
            return _openBlock(), _createElementBlock("div", {
              class: "radio-set-row",
              key: item.value
            }, [_createVNode(_component_el_radio, {
              label: item.value,
              name: item.name
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.name), 1)];
              }),
              _: 2
            }, 1032, ["label", "name"])]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])], 512), [[_vShow, tabIndex.value == 8]])], 8, _hoisted_19), _createElementVNode("div", _hoisted_190, [_createElementVNode("div", _hoisted_191, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: handelSaveBook
      }, {
        default: _withCtx(function () {
          return [_hoisted_192];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        plain: "",
        onClick: handelSaveBook
      }, {
        default: _withCtx(function () {
          return [_hoisted_193];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        plain: ""
      }, {
        default: _withCtx(function () {
          return [_hoisted_194];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: ""
      }, {
        default: _withCtx(function () {
          return [_hoisted_195];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        plain: ""
      }, {
        default: _withCtx(function () {
          return [_hoisted_196];
        }),
        _: 1
      })]), _hoisted_197, _createElementVNode("div", _hoisted_198, [_createVNode(_component_el_carousel, {
        "indicator-position": "outside",
        autoplay: false
      }, {
        default: _withCtx(function () {
          return [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, function (item) {
            return _createVNode(_component_el_carousel_item, {
              key: item
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_199, [_createElementVNode("div", _hoisted_200, _toDisplayString(item), 1)])];
              }),
              _: 2
            }, 1024);
          }), 64))];
        }),
        _: 1
      })])])])], 64);
    };
  }
};